import { Component, input, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { CardContent } from '@models/card-content';

/**
 * Release card component
 * displays the latest release report with a fixed image,
 * hardcoded tags and a read more button.
 * title, date and href come from the RSS feed via @Input data.
 * image and tags can be overridden via inputs but have sensible defaults.
 * @class ReleaseCardComponent
 */
@Component( {
    selector: 'riege-release-report',
    imports: [ MatCardModule, MatButtonModule, MatChipsModule ],
    templateUrl: './release-report.component.html',
    styleUrl: './release-report.component.scss',
    encapsulation: ViewEncapsulation.None
} )
export class ReleaseReportComponent {
    /** feed data: title, date, href */
    readonly data = input.required<CardContent>();

    /** fixed image, can be overridden per release if needed */
    readonly image = input( 'assets/images/release-report-img.png' );

    /** hardcoded text since the json api doesnt provide it... */
    readonly text = input(
        $localize`:@@input-release-report-text:Discover all new new features and enhancements of the new Scope version 26.8. This release report will guide you through the significant updates crafted to transform your workflow.`
    );
    /** tags, can be overridden if needed */
    readonly tags = input<string[]>( [
        $localize`:@@tag-air-freight:Air Freight`,
        $localize`:@@tag-customs:Customs`,
        $localize`:@@tag-finance:Finance`,
        //$localize`:@@tag-forwarding:Forwarding`,
        $localize`:@@tag-ocean-freight:Ocean Freight`,
        //$localize`:@@tag-co2-footprint:CO2 Footprint`,
        //$localize`:@@tag-germany:Germany`,
        $localize`:@@tag-feature:Feature`,
        $localize`:@@tag-update:Update`
    ] );
}
